<template>
    <div class="all-body">
        <Topbar/>
        <div class="content-body">
            <div></div>
            <div>
                <a-table :dataSource="sourceData" :columns="columns_info" :pagination="pageData" :scroll="{ x: 'max-content' }"  >
                </a-table>
            </div>
            <div style="width: 200px;">
                <a-table :draggable="true" :dataSource="colDatas" :columns="col_info" :pagination="false" size="small" >
                    <template #bodyCell="{column, record}">
                        <template v-if="column.key === 'drag'">
                            <HolderOutlined />
                        </template>
                    </template>
                </a-table>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, nextTick,reactive } from 'vue'
import { SearchOutlined,DownOutlined, CopyOutlined, ClockCircleOutlined,FileProtectOutlined,FileUnknownOutlined,HolderOutlined } from '@ant-design/icons-vue'
import Topbar from '@/components/TopBar.vue'
import T86 from '@/components/T86.vue'
import Api from '@/api/Api'
import { message } from 'ant-design-vue'
import { useRoute } from 'vue-router'

export default defineComponent({
    name : 'Fantracking',
    components :{
        Topbar,
        HolderOutlined
    },
    setup(){
        const sourceData = ref()
        const columns_info = ref([
            { title: "MBOL",rowDrag: true, index: 1},
            { title: "Container#",rowDrag: true,index: 2},
            { title: "ETD", sorter : true,rowDrag: true,index: 3},
            { title: "ETA", sorter : true,rowDrag: true,index: 4},
            { title: "POD",index: 5},
            { title: "Destination",index: 6},
            { title: "CTN PCS",index: 7},
            { title: "House PCS",index: 8},
            { title: "AMS",index: 9},
            { title: "ISF",index: 10},
            { title: "T86",index: 11},
            { title: "Firm Code",index: 12},
            { title : "Terminal Customs",  filters: [{ text: 'Hold', value: 'hold' },{ text: 'Release', value: 'release' }], index: 13},
            { title : "Terminal FREIGHT", index: 14},
            { title: "Status",index: 15},
            { title: "LFD", sorter : true,index: 16},
            { title: "PIERPASS", sorter : true,index: 17},
            { title: "CTF",index: 18},
        ])
        
        const colDatas = ref([])

        for(let key in columns_info.value){
            let obj : any = {
                data: columns_info.value[key].title,
                index: columns_info.value[key].index
            }
            colDatas.value.push(obj)
        }

        const col_info = [
            {key: "drag",width: "30px"},
            {key : "content", dataIndex : "data", width:"100px"}
        ]

        const pageData = reactive({
            current : 1,
            pageSize : 10,
            total : 0,
            showSizeChanger : false,
            showQuickJumper : false,
            showLessItems : false,
        })
        return {
            sourceData,
            columns_info,
            pageData,
            col_info,
            colDatas
        }
    },
})
</script>
<style scoped>
.all-body {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background: #F5F5F5;
}
.content-body {
    background-color: #FFFFFF;
    margin: 0px 24px 24px 24px;
    height: -webkit-fill-available;
}
</style>